import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { BrowserCompatibilityService } from '../browser-compatibility.service';

@Injectable({
  providedIn: 'root'
})
export class BrowserCompatibilityGuard  {
  constructor(
    private router: Router,
    private browserCompatibilityService: BrowserCompatibilityService
  ) { }

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): any {
    return this.checkBrowser();
  }

  canActivateChild(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): any {
    return this.checkBrowser();
  }

  canLoad(_route: Route, _segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkBrowser();
  }

  private checkBrowser(): boolean {
    const browserCompatible = this.browserCompatibilityService.isBrowserCompatible();
    if (!browserCompatible) {
      // noinspection JSIgnoredPromiseFromCall
      this.router.navigate(['/browser-not-supported']);
    }
    return browserCompatible;
  }
}
